import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import Popper from '@material-ui/core/Popper';

// CONSTANTS
import { WHITE, MAIN_BLACK, GRAY_SUIT } from '@/constants/colors';

export const TooltipPopperComponent = styled(Popper)`
  ${({ theme, cardwidth, cardheight, tooltipheight }) => {
    const PADDING = 15;
    const borderRadius = 14;
    const contentPadding = cardwidth > 240 ? '24px 16px' : `${PADDING}px`;
    const MARGIN = PADDING;

    return css`
      z-index: 1210;
      margin-top: -${(tooltipheight - cardheight) / 2}px;
      cursor: pointer;

      &[x-placement='left-start'] {
        margin-right: -${(cardwidth + cardwidth + MARGIN) / 2}px;
      }

      &[x-placement='right-start'] {
        margin-left: -${(cardwidth + cardwidth + MARGIN) / 2}px;
      }

      .MuiTooltip-tooltip {
        width: ${cardwidth + MARGIN * 2}px;
        height: ${cardheight + MARGIN * 2}px;
        min-width: 405px;
        min-height: 236px;
        padding: 0;
        margin: 0;
        border-radius: ${borderRadius}px;
        box-shadow: 0 4px 24px 0 ${rgba(MAIN_BLACK, 0.15)};
        background-color: ${theme.palette.showMovieCard.hoverBg};
        color: ${theme.palette.showMovieCard.hoverText};
        display: flex;

        .episode-card__content {
          padding: ${contentPadding};
        }
      }
    `;
  }}
`;

export const EpisodeCardImage = styled.div`
  ${({ $background }) => css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    pointer-events: none;

    background-image: url(${$background.image});
    background-size: ${$background.size};
    background-repeat: no-repeat;
    background-position: center center;
    border-radius: 4px;
  `}
`;

export const EpisodeCardContainer = styled.div`
  .episode-card,
  &.episode-card {
    position: relative;
    outline: none;
    cursor: pointer;
    width: 100%;

    display: flex;
    flex-direction: column;

    &__img-container {
      width: 100%;
      height: 0;
      overflow: hidden;
      padding-top: 56%;
      background: ${WHITE};
      position: relative;
      border-radius: 4px;
    }

    &__main-info {
      flex: 1;

      width: 100%;
      margin-top: 4px;

      display: flex;
      flex-direction: column;
    }

    &--fullHeight {
      min-height: 100%;
    }

    &--loading {
      cursor: default;
    }
  }
`;

export const EpisodeCardContentStyled = styled.div`
  ${({ theme: { palette } }) => css`
    padding: 15px;
    height: 100%;

    display: flex;

    .episode-card,
    &.episode-card {
      padding: 0;

      &--tooltip {
        color: ${palette.showMovieCard.hoverText};

        .episode-card__title {
          color: inherit;
        }
      }

      &--loading {
        background-color: ${palette.secondary.main};
      }


    }

    .episode-content,
    &.episode-content {
      &__title {
        font-weight: 600;
        line-height: 20px;
        margin-bottom: 12px;
      }

      &__subtitle {
        font-weight: 400;
        color: ${GRAY_SUIT};
        margin-bottom: 12px;
        white-space: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
      }

      &__description {
        font-weight: 400;
      }

      &__section {
        width: 100%;
      }

      &__apps {
        margin-top: 12px;
      }

      &--tooltip {
        min-height: 246px;

        .episode-content__section {
          display: flex;
          flex-direction: column;
        }

        .episode-content__divider {
          background-color: ${GRAY_SUIT};
          margin-bottom: 12px;
        }
    }
  `}
`;

export const AppsListStyled = styled.div`
  .apps-title {
    color: ${GRAY_SUIT};
    font-weight: 400;
    margin-bottom: 8px;
  }

  .apps-list {
    display: flex;
    min-height: 52px;

    .app-card {
      width: 85px;
      height: 48px;
      border-radius: 6px;
      background-color: ${({ theme: { palette } }) => palette.common.white};

      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;

      display: flex;
      align-items: center;
      justify-content: center;
    }

    .app-card + .app-card {
      margin-left: 12px;
    }
  }

  &.apps {
    &--default,
    &--tooltip {
      .apps-list {
        width: calc(100% + 8px);
        margin: -4px;
        padding: 4px;

        .MuiGrid-container {
          width: calc(100% + 8px);
          margin: -4px;
        }

        .MuiGrid-item {
          padding: 6px;
        }
      }
    }
  }
`;

export default EpisodeCardContainer;
